export const ConsumerPhoneValidationErrorGeneralUat = {
  error: 'phoneValidation.generalError',
}
